import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyANQ675ElWgy6WJUJkRSJPndmQDzJ-dZSg",
  authDomain: "school-erp-851cb.firebaseapp.com",
  projectId: "school-erp-851cb",
  storageBucket: "school-erp-851cb.firebasestorage.app",
  messagingSenderId: "1026237139411",
  appId: "1:1026237139411:web:2460063d3ce995b1e10726",
  measurementId: "G-PBVWW93S50"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;